import React from 'react';
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';

function AuthorPage() {
    return (
        <div css={style}>
            작가 상세
        </div>
    );
}

const style = css`

`;

export default AuthorPage;
